import React from 'react';

import { ContentWrapper, Main } from '../../styles/global.styles';
import Footer from '../footer/footer.component';
import Navbar from '../navbar/navbar.component';

type State = {
  hasError: boolean;
  error?: Error | null;
};

type Props = {
  children: React.ReactNode;
};

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // You can log the error to an external service here
    // For now, just log to console
    // eslint-disable-next-line no-console
    console.error('Uncaught error in ErrorBoundary:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Main>
          <Navbar />
          <ContentWrapper
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-around',
            }}
          >
            <div
              style={{
                maxWidth: '50vw',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img
                style={{ width: '100%', height: 'auto' }}
                src="/error.png"
                alt="error-image"
              />
            </div>
            <div style={{ padding: 24 }}>
              <h1>Stone cut, but page not found.</h1>
              <p>
                We&apos;re sorry — an unexpected error occurred. Please try
                refreshing the page.
              </p>
              <details style={{ whiteSpace: 'pre-wrap' }}>
                {this.state.error?.message}
              </details>
            </div>
          </ContentWrapper>
          <Footer />
        </Main>
      );
    }

    return this.props.children as React.ReactElement;
  }
}
